/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { EstatePeriod, Granularity, DateRange } from "~/components";
import { EstateRecordsCostPerOrgUnit } from "~/views/estate/components/Charts";
import { getEndDate, getStartDate } from "./components/helpers";

type Props = {
  period: EstatePeriod;
  granularity: Granularity;
  range: DateRange;
};

export function EstateRecordsOrgUnitView({
  period,
  granularity,
  range,
}: Props) {
  const startDate =
    range.from ?? getStartDate(EstatePeriod.DEFAULT_MONTH, undefined);
  const endDate = range.to ?? getEndDate(EstatePeriod.DEFAULT_MONTH, undefined);

  return (
    <EstateRecordsCostPerOrgUnit
      granularity={granularity}
      startDate={startDate}
      endDate={endDate}
      period={period}
    />
  );
}
